/**
 * IST121026 - before checkout, tell the checkout which pickup stores have no stock for each tracked
 * Apple item that is not DG (cart?view=stock-snapshot lists them), so it can show
 * "Available for backorder" at those stores:
 *   cart attribute _stockSnapshot = {"<variant id>": ["<location id>", ...]}
 *   [] = every store has stock, ["all"] = no store has stock
 * Stores and stock come from the same source as the location drawer. Every checkout button is a
 * [name="checkout"] submit, so one capture listener writes the snapshot, then replays the click and
 * the existing checkout handlers (VAT, max quantity) run as before.
 */
(function () {
  const REPLAY = 'stockSnapshotReplay';

  async function writeStockSnapshot() {
    const root = window.Shopify.routes.root;
    const variantIds = await (await fetch(`${root}cart?view=stock-snapshot`)).json();
    const snapshot = {};

    if (variantIds.length) {
      const token = document.querySelector('my-store-locator')?.dataset.storefrontApiAccessToken;
      const query = `query ($ids: [ID!]!) {
        nodes(ids: $ids) {
          ... on ProductVariant {
            id
            storeAvailability(first: 50) {
              nodes {
                quantityAvailable
                location { id toggles: metafield(namespace: "apple", key: "apl_EnableToggles") { value } }
              }
            }
          }
        }
      }`;
      const response = await fetch(`https://${window.Shopify.shop}/api/2024-07/graphql.json`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
        body: JSON.stringify({ query, variables: { ids: variantIds.map((id) => `gid://shopify/ProductVariant/${id}`) } }),
      });
      const { data } = await response.json();

      data.nodes.forEach((variant) => {
        if (!variant) return;
        // the drawer hides stores with storeLocatorEnabled off, so they do not count here either
        const stores = variant.storeAvailability.nodes.filter(
          (store) => JSON.parse(store.location.toggles?.value || null)?.storeLocatorEnabled !== false
        );
        const noStock = stores.filter((store) => (store.quantityAvailable || 0) <= 0);
        snapshot[variant.id.split('/').pop()] =
          stores.length && noStock.length === stores.length ? ['all'] : noStock.map((store) => store.location.id.split('/').pop());
      });
    }

    await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { _stockSnapshot: JSON.stringify(snapshot) } }),
    });
  }

  document.addEventListener(
    'click',
    async (event) => {
      const button = event.target.closest('[name="checkout"]');
      if (!button || button.disabled || button.dataset[REPLAY]) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      try {
        await writeStockSnapshot();
      } catch (error) {
        // never block the checkout: without a valid snapshot the checkout keeps its default pickup text
        console.warn('IST121026 _stockSnapshot not written', error);
      }

      button.dataset[REPLAY] = 'true';
      button.click();
      delete button.dataset[REPLAY];
    },
    true
  );
})();
